<template>
  <div class="home_view">
    <!-- Hero -->
    <section class="hero">
      <div class="home_inner hero_inner">
        <div class="hero_content">
          <h1 class="hero_title">
            Check the history of any Chinese vehicle – instantly
          </h1>
          <p class="hero_subtitle">
            Get a free VIN lookup with Lemon Check – access accident records,
            mileage history, insurance claims &amp; more
          </p>

          <div class="vin_search">
            <div class="vin_search_field">
              <!-- <span class="vin_search_badge">VIN</span>
              <input
                v-model="vin"
                class="vin_search_input"
                type="text"
                maxlength="17"
                placeholder="Enter a 17-digit VIN..."
                @keyup.enter="handleCheckVin"
              />
              <button class="vin_search_btn" type="button" @click="handleCheckVin">
                Check VIN
              </button> -->
              <vin-input type="large"></vin-input>
            </div>
            <div class="vin_search_hint">
              <span>17 chars • No I, O or Q • Found on dashboard or registration doc</span>
              <a class="vin_search_link" href="javascript:;" @click="whatsVin">Where is my VIN?</a>
            </div>
          </div>

          <ul class="hero_features">
            <li
              v-for="item in serveList"
              :key="item.text"
              class="hero_features_item flex_center"
            >
              <img :src="item.icon" class="hero_features_icon" alt="" />
              <span>{{ item.text }}</span>
            </li>
          </ul>

          <div class="hero_supports">
            <span class="hero_supports_label">SUPPORTS:</span>
            <div
              v-for="item in supportList"
              :key="item.text"
              class="hero_supports_item"
            >
              <img :src="item.icon" class="hero_supports_icon" alt="" />
              <span>{{ item.text }}</span>
            </div>
          </div>

          <p class="hero_alt">
            Don't have a VIN?
            <a class="hero_alt_link" href="javascript:;" @click="purchasePackage">Purchase a package</a>
            instead.
          </p>
        </div>

        <div class="hero_visual">
          <img :src="bannerIcon" class="hero_banner" alt="Vehicle history check" />
        </div>
      </div>
    </section>

    <!-- Statistics -->
    <section class="statistics flex_center">
      <div class="home_inner statistics_inner flex_between">
        <div
          v-for="item in statisticsList"
          :key="item.value"
          class="statistics_item flex_center"
        >
          <img :src="item.icon" class="statistics_icon" alt="" />
          <div class="statistics_text">
            <div class="statistics_value">{{ item.value }}</div>
            <div class="statistics_desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Why it matters -->
    <section class="why">
      <div class="home_inner why_inner">
        <div class="why_left">
          <div class="why_label flex_column">
            <span class="why_label_line"></span>
            <span>WHY IT MATTERS</span>
          </div>
          <h2 class="why_title">
            <span class="why_title_em">Don't</span> buy blind. Know before you pay.
          </h2>
          <p class="why_desc">
            Exported vehicle purchases carry hidden risks. A Lemon Check report gives overseas buyers full visibility into a vehicle's real history — before money changes hands.
          </p>

          <div class="why_cards">
            <div class="why_card why_card_danger">
              <div class="flex">
                <img :src="contentIcon1" class="why_card_icon" alt="" />
                <div class="why_card_value">70%</div>
              </div>
              <div class="why_card_desc">
                of used car buyers have experienced intentional manipulation by sellers
              </div>
            </div>
            <div class="why_card why_card_info">
              <div class="flex">
                <img :src="contentIcon2" class="why_card_icon" alt="" />
                <div class="why_card_value">5-10%</div>
              </div>
              
              <div class="why_card_desc">
                vehicle value increase when a history report is attached to the listing
              </div>
            </div>
          </div>
        </div>

        <div class="why_right">
          <img :src="contentBg" class="why_table" alt="Report comparison" />
          <img :src="contentImage" class="why_monitor" alt="Sample report" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import bannerIcon from '@/assets/images/home/banner_icon.png'
import contentBg from '@/assets/images/home/content_bg.png'
import contentImage from '@/assets/images/home/content_image.png'
import contentIcon1 from '@/assets/images/home/content_icon1.png'
import contentIcon2 from '@/assets/images/home/content_icon2.png'
import statisticsIcon1 from '@/assets/images/home/statistics_icon1.png'
import statisticsIcon2 from '@/assets/images/home/statistics_icon2.png'
import statisticsIcon3 from '@/assets/images/home/statistics_icon3.png'
import statisticsIcon4 from '@/assets/images/home/statistics_icon4.png'
import serveIcon1 from '@/assets/images/home/serve_icon1.png'
import serveIcon2 from '@/assets/images/home/serve_icon2.png'
import serveIcon3 from '@/assets/images/home/serve_icon3.png'
import supportIcon1 from '@/assets/images/home/support_icon1.png'
import supportIcon2 from '@/assets/images/home/support_icon2.png'
import supportIcon3 from '@/assets/images/home/support_icon3.png'
import VinInput from '@/components/VinInput.vue'

export default {
  name: 'HomeView',
  components: {
    VinInput
  },
  data() {
    return {
      vin: '',
      bannerIcon,
      contentBg,
      contentImage,
      contentIcon1,
      contentIcon2,
      serveList: [
        { icon: serveIcon1, text: 'Uncover Hidden Accident History' },
        { icon: serveIcon2, text: 'Verify Mileage Authenticity' },
        { icon: serveIcon3, text: 'Check Vehicle Risk Records' }
      ],
      supportList: [
        { icon: supportIcon1, text: 'Passenger Cars' },
        { icon: supportIcon2, text: 'Trucks & SUVs' },
        { icon: supportIcon3, text: 'EVs & NEVs' }
      ],
      statisticsList: [
        {
          icon: statisticsIcon1,
          value: '50K+',
          desc: 'Data institutions as sources'
        },
        {
          icon: statisticsIcon2,
          value: '4M+',
          desc: 'Reports delivered to customers'
        },
        {
          icon: statisticsIcon3,
          value: '24/7',
          desc: 'Instant access, PDF + online'
        },
        {
          icon: statisticsIcon4,
          value: 'CADA',
          desc: 'China Automobile Dealers Association'
        }
      ]
    }
  },
  methods: {
    handleCheckVin() {
      const value = (this.vin || '').trim().toUpperCase()
      if (!value) return
      // VIN check flow to be wired later
      console.log('check vin:', value)
    },
    purchasePackage() {
      this.$router.push("/pay")
    },
    whatsVin() {
      if (this.$route.path !== "/vehicle-history/vin-introduction") {
        this.$router.push("/vehicle-history/vin-introduction")
      }
    }
  }
}
</script>

<style scoped lang="scss">
.home_view {
  width: 100%;
  font-family: 'Alibaba PuHuiTi 3.0', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #1a2332;
  background: #fff;

  // 公共容器（与 hero_inner/statistics_inner/why_inner 位于同一元素上）
  .home_inner {
    width: 1600px;
    margin: 0 auto;
  }

  /* ===== Hero ===== */
  .hero {
    position: relative;
    background: url('/src/assets/images/home/banner_bg.png') no-repeat;
    background-color: linear-gradient(180deg, #e8f1ff 0%, #f5f9ff 42%, #ffffff 100%);
    background-size: 100% 100%;
    overflow: hidden;

    .hero_inner {
      position: relative;
      padding: 48px 0 40px;
      min-height: 590px;

      .hero_content {
        position: relative;
        z-index: 2;
        /* width: 720px; */
        padding-top: 28px;

        .hero_title {
          font-size: 52px;
          font-weight: 700;
          line-height: 1.2;
          letter-spacing: -0.02em;
          color: #1a2332;
        }

        .hero_subtitle {
          margin-top: 20px;
          /* max-width: 620px; */
          font-size: 22px;
          display: flex;
          align-items: center;
          letter-spacing: -0.02em;
          color: #6A768D;
        }

        .vin_search {
          margin-top: 36px;

          .vin_search_field {
            width: 100%;
            max-width: 800px;
          }

          .vin_search_badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 42px;
            height: 28px;
            padding: 0 8px;
            margin-right: 12px;
            border-radius: 6px;
            background: #003eb0;
            color: #fff;
            font-size: 12px;
            font-weight: 700;
            letter-spacing: 0.04em;
            flex-shrink: 0;
          }

          .vin_search_input {
            flex: 1;
            min-width: 0;
            height: 100%;
            font-size: 16px;
            color: #1a2332;
            letter-spacing: -0.01em;

            &::placeholder {
              color: #9aa3b2;
            }
          }

          .vin_search_btn {
            flex-shrink: 0;
            height: 52px;
            padding: 0 28px;
            border-radius: 10px;
            background: linear-gradient(270deg, #ffcc00 0%, #fcd42d 99%), #ffcc00;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: -0.02em;
            color: #333;
            transition: filter 0.2s ease, transform 0.2s ease;

            &:hover {
              filter: brightness(0.98);
              transform: translateY(-1px);
            }
          }

          .vin_search_hint {
            display: flex;
            justify-content: space-between;
            width: 800px;
            align-items: center;
            flex-wrap: wrap;
            /* gap: 8px 16px; */
            margin-top: 14px;
            font-size: 18px;
            color: #8b93a3;
            font-weight: 500;
            letter-spacing: -0.02em;

            .vin_search_link {
              color: #1B6FE8;
              font-weight: 500;
              /* text-decoration: underline;
              text-underline-offset: 2px; */

              &:hover {
                color: #002f8a;
              }
            }
          }
        }

        .hero_features {
          display: flex;
          align-items: flex-start;
          /* gap: 28px; */
          margin-top: 36px;
          width: 670px;
          height: 62px;
          border-radius: 8px;
          border: 1px solid #D2DDF0;

          .hero_features_item {
            gap: 10px;
            min-width: 220px;
            height: 100%;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.4;
            letter-spacing: -0.01em;
            color: #334155;
            padding: 0 16px;

            &:nth-child(2) {
              border-left: 1px solid #D2DDF0;
              border-right: 1px solid #D2DDF0;
            }
          }

          .hero_features_icon {
            width: 46px;
            height: 46px;
            object-fit: contain;
            flex-shrink: 0;
          }
        }

        .hero_supports {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px 22px;
          margin-top: 58px;
          color: #6A768D;

          .hero_supports_label {
            font-size: 18px;
            font-weight: 500;
            letter-spacing: -0.02em;
          }

          .hero_supports_item {
            display: inline-flex;
            align-items: center;

            .hero_supports_icon {
              width: 32px;
              height: 32px;
              object-fit: contain;
            }
          }
        }

        .hero_alt {
          margin-top: 15px;
          font-size: 18px;
          color: #6A768D;
          letter-spacing: -0.02em;

          .hero_alt_link {
            color: #1B6FE8;
            font-weight: 500;
            text-decoration: underline;
            text-underline-offset: 2px;

            &:hover {
              color: #002f8a;
            }
          }
        }
      }

      .hero_visual {
        position: absolute;
        top: 155px;
        right: 0;
        z-index: 1;
        width: 684px;
        pointer-events: none;

        .hero_banner {
          display: block;
          width: 820px;
          height: auto;
        }
      }
    }
  }

  /* ===== Statistics ===== */
  .statistics {
    background: #F9FAFC;
    padding: 50px 320px;

    .statistics_inner {
      flex-shrink: 0;
      /* width: 1600px; */
      /* padding: 12px 40px; */

      .statistics_item {
        width: 387px;
        height: 112px;
        border-radius: 12px;
        background: #FFFFFF;
        gap: 16px;
        min-width: 0;

        .statistics_icon {
          width: 80px;
          height: 80px;
          object-fit: contain;
          flex-shrink: 0;
        }

        .statistics_text {
          .statistics_value {
            font-size: 30px;
            font-weight: bold;
            letter-spacing: 0;
            color: #42464C;
          }

          .statistics_desc {
            margin-top: 4px;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: -0.02em;
            color: rgba(51, 51, 51, 0.8);
          }
        }
      }
    }
  }

  /* ===== Why it matters ===== */
  .why {
    padding: 72px 0 90px;
    background: #F0F4FA;
    // 裁剪绝对定位的 .why_monitor 超出区块的溢出部分，避免触发页面级横向滚动条
    overflow: hidden;

    .why_inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 40px;

      .why_left {
        width: 595px;
        flex-shrink: 0;

        .why_label {
          font-size: 18px;
          font-weight: 500;
          line-height: normal;
          letter-spacing: -0.02em;
          color: #1B6FE8;

          .why_label_line {
            display: block;
            width: 35px;
            height: 4px;
            background: #1B6FE8;
            margin-bottom: 8px;
          }
        }

        .why_title {
          font-size: 46px;
          font-weight: bold;
          letter-spacing: -0.02em;
          color: #333;

          .why_title_em {
            color: #E84040;
          }
        }

        .why_desc {
          font-size: 20px;
          font-weight: 500;
          line-height: normal;
          display: flex;
          align-items: center;
          letter-spacing: -0.02em;
          margin-top: 40px;
          color: #6A768D;
        }

        .why_cards {
          display: flex;
          gap: 16px;
          margin-top: 36px;

          .why_card {
            flex: 1;
            padding: 20px 18px 22px;
            border-radius: 14px;

            .why_card_icon {
              width: 44px;
              height: 44px;
              object-fit: contain;
              margin-right: 12px;
            }

            .why_card_value {
              /* margin-top: 14px; */
              font-size: 36px;
              font-weight: 700;
              line-height: 1;
              letter-spacing: -0.02em;
            }

            .why_card_desc {
              margin-top: 10px;
              font-size: 13px;
              line-height: 1.5;
              letter-spacing: -0.01em;
            }

            &.why_card_danger {
              background: #fff1f0;
              border: 1px solid #ffd4d0;

              .why_card_value {
                color: #e11d2e;
              }

              .why_card_desc {
                color: #9a4a46;
              }
            }

            &.why_card_info {
              background: #eef5ff;
              border: 1px solid #d0e2ff;

              .why_card_value {
                color: #003eb0;
              }

              .why_card_desc {
                color: #4a648a;
              }
            }
          }
        }
      }

      .why_right {
        position: relative;
        flex: 1;
        min-height: 480px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .why_table {
          width: 965px;
          height: 480px;
          max-width: 100%;
          height: auto;
          position: relative;
          z-index: 1;
        }

        .why_monitor {
          position: absolute;
          right: -100px;
          bottom: -20px;
          width: 265px;
          height: auto;
          z-index: 2;
          filter: drop-shadow(0 18px 40px rgba(15, 47, 107, 0.18));
        }
      }
    }
  }
}
.email-box {
  margin: 30px auto;
}
</style>
